<template>
    <el-pagination
        class="kt-page"
        background
        @size-change="handleSizeChange"
        @current-change="refreshPageRequest"
        :current-page="pageNum"
        :page-size="limit"
        :page-sizes="pageSizeList"
        layout="total, sizes, prev, pager, next"
        :total="pageCount">
    </el-pagination>
</template>

<script>
export default {
    name:'OrderPag',
    props:{
        pageCount: { //总页数
            type: Number,
            default: 0
        },
        currentPage: { //页码
            type: Number,
            default: 1
        },
        limit: { //页数
            type: Number,
            default: 10
        },
        pageSizeList: { //页码数值
            type: Array,
            default(){
                return [10, 20, 50, 100, 200]
            }
        }
    },
    data() {
        return {
            pageNum: 1,
            pageLimit: 10
        }
    },
    created(){
        this.pageNum = this.currentPage
        this.pageLimit = this.limit
    },
    methods:{
        refreshPageRequest(val){
            this.pageNum = val
            this.handleChange()
        },
        handleSizeChange(val){
            this.pageNum = 1
            this.pageLimit = val
            this.handleChange()
        },
        handleChange(){
            this.$emit('onChange', { page: this.pageNum, limit: this.pageLimit })
        }
    },
    watch:{
        currentPage:function(val,oldval){
            this.pageNum = val
        },
        limit:function(val,oldval){
            this.pageLimit = val
        }
    }
}
</script>

<style lang="scss">
.kt-page{
    text-align: center;
    margin-top: 12px;
    overflow-y: hidden;
    font-weight: normal !important;
}
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
    background-color: #F2F2F2 !important;
    border: none ;
}
.el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #f48c06 !important; 
    color:#FFFFFF !important;
}
.el-pager li.btn-quicknext, .el-pager li.btn-quickprev{
    border: none !important;
}
.kt-page>.el-select-dropdown__item.selected{//todo不生效
    color: #f48c06;
}
</style>